<template>
  <div class="section">
    <Modal
      width="800"
      v-model="isShowchooseRecipeModal"
    >
      <div
        class="table-wrapper"
        ref="tableWrapper"
      >
        <div class="handle-wrapper">
          <div class="handle-left">
            {{salesOrder?salesOrder.abbr:""}}
          </div>
          <div class="handle-right">
            <span>共{{ recipetotalRows }}条</span>
            <Page
              :total="recipetotalRows"
              :page-size="15"
              @on-change="loadRecipe"
              show-total
              simple
              style="margin-right: 24px"
            />
          </div>
        </div>
        <Table
          :columns="columns"
          :data="recipeSalesList"
          :loading="recipeLoading"
          :height="tableHeight"
          @on-row-click='chooseRecipe'
        > </Table>
      </div>
    </Modal>
    <h2 class="section-title">生产订单</h2>
    <div
      v-for="d in displayData"
      class="section-block"
    >
      <h3 class="block-title">{{ d.title }}</h3>
      <div
        :class="{
          'block-displaycontent': !d.lock ,
        }"
        @click="!d.lock && openRecipeChooseDrawer(d)"
      ><span class="block-displaytext">{{ d.displayText || "-" }}</span></div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapState } from "vuex";
const statusToText = {
  created: "未接单",
  verified: "合格",
  reviewing: "待验收",
  rejected: "不合格",
  canceled: "已取消",
};
export default {
  name: "SecSOP",
  data() {
    return {
      salesOrder: null,
      displayData: {
        factory: {
          key: "factory",
          title: "工厂",
          lock: true,
          type: "String",
          displayText: "-",
        },
        prodRecipe: {
          key: "prodRecipe",
          title: "配方",
          lock: false,
          type: "String",
          displayText: "-",
        },
        startedAt: {
          key: "startedAt",
          title: "开始时间",
          lock: true,
          type: "DateTime",
          displayText: "-",
        },
        finishedAt: {
          key: "finishedAt",
          title: "结束时间",
          lock: true,
          type: "DateTime",
          displayText: "-",
        },
        createdBy: {
          key: "createdBy",
          title: "创建人",
          lock: true,
          type: "String",
          displayText: "-",
        },
        createdAt: {
          key: "createdAt",
          title: "创建时间",
          lock: true,
          type: "String",
          displayText: "-",
        },
      },
      isShowchooseRecipeModal: false,
      prodRecipe: null,
      columns: [
        {
          title: "生产配方",
          key: "createdBy",
          align: "center",
          minWidth: 80,
          maxWidth: 80,
          render: (h, params) => {
            return h("div", [
              h("div", params.row._id === this.prodRecipe ? "是" : ""),
            ]);
          },
        },
        {
          title: "配方",
          key: "recipe",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  cursor: "pointer",
                  color: "#42b983",
                },
              },
              [h("div", params.row.name)]
            );
          },
        },
        {
          title: "NoId",
          key: "NoId",
          align: "center",
          render: (h, params) => {
            return h("div", [h("div", "#" + params.row.NoId)]);
          },
        },

        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("div", params.row.createdBy ? params.row.createdBy.name : ""),
            ]);
          },
        },
        {
          title: "创建时间",
          key: "createdAt",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("div", dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")),
            ]);
          },
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          render: (h, params) => {
            return h("div", [h("div", statusToText[params.row.status])]);
          },
        },
      ],
      tableHeight: 500,
      recipeLoading: false,
      recipePage: 0,
    };
  },
  computed: {
    ...mapState({
      recipeSalesList: (state) => state.recipeSales.recipeSalesList,
      recipetotalRows: (state) => state.recipeSales.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getRecipeSales: "recipeSales/getRecipeSalesAction",
      updateSalesOrder: "salesOrder/updateSalesOrderAction",
      getSalesById: "sales/getSalesByIdAction",
    }),
    loadData(payload) {
      this.salesOrder = payload.SPO;
      if (!this.salesOrder) return;
      this.displayData.factory.displayText = this.salesOrder.factory.name;
      this.displayData.prodRecipe.displayText =
        "#" + this.salesOrder?.recipe.NoId + " " + this.salesOrder?.recipe.name;
      this.displayData.startedAt.displayText = this.salesOrder.startedAt
        ? dayjs(this.salesOrder.startedAt).format("M月D日 HH:mm")
        : null;
      this.displayData.finishedAt.displayText =
        this.salesOrder.finishedAt && this.salesOrder.finishedAt
          ? dayjs(this.salesOrder.finishedAt).format("M月D日 HH:mm")
          : null;
      this.displayData.createdAt.displayText = this.salesOrder.createdAt
        ? dayjs(this.salesOrder.createdAt).format("M月D日 HH:mm")
        : null;
      this.displayData.createdBy.displayText = this.salesOrder.startedBy
        ? this.salesOrder.startedBy.name
        : null;
    },
    // 打开
    async openRecipeChooseDrawer() {
      const data = await this.getSalesById(this.salesOrder.sales._id);
      if (data.prodRecipe) {
        this.prodRecipe = data.prodRecipe._id;
      }
      this.loadRecipe();
      this.isShowchooseRecipeModal = true;
    },
    async loadRecipe(page) {
      if (page) this.recipePage = page - 1;
      let api = {
        skip: this.recipePage * 15,
        limit: 15,
        sales: this.salesOrder.sales._id,
      };
      try {
        this.recipeLoading = true;
        await this.getRecipeSales(api);

        this.recipeLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.recipeLoading = false;
      }
    },
    async chooseRecipe(e) {
      const data = await this.updateSalesOrder({
        id: this.salesOrder._id,
        data: { recipe: e._id },
      });
      this.displayData.prodRecipe.displayText =
        "#" + data?.recipe.NoId + " " + data?.recipe.name;
      this.isShowchooseRecipeModal = false;
    },
  },
  watch: {},
};
</script>

<style scoped lang="stylus">
.section
  display flex
  align-content flex-start
  flex-wrap wrap
  margin-bottom 12px

.section-title
  width 100%
  font-weight 450
  margin-bottom 12px
  color #3e3e3e

.block-title
  float left
  width 130px
  font-weight 400
  color #888

.block-displaytext
  float left
  font-weight 450
  font-size 14px

.block-displaycontent
  cursor pointer
  transition 0.2s
  flex-grow 1
  max-height 90px
  overflow hidden
  padding 0 4px
  line-height 27px
  border 1px solid white

  &:hover
    border 1px solid darkgray
    background-color #f7f7f7
    border-radius 2px

.section-block
  width 50%
  line-height 26px
  margin-bottom 8px
</style>
